function isMobileDevice() {
  return window.innerWidth <= 1200;
}

function resetAll(scope) {
  const root = scope || document;
  root.querySelectorAll(".main-header-nav .sub-menu").forEach((item) => {
    item.classList.remove("active");
  });
  root.querySelectorAll(".main-header-nav .menu-item-has-children > a").forEach((item) => {
    item.classList.remove("open");
  });
}

function changePointerEventsHeaderMobile() {
  document.addEventListener("click", (event) => {
    if (!isMobileDevice()) {
      return;
    }

    const clickedLink = event.target.closest(".main-header-nav a");
    const parentItem = event.target.closest(
      ".main-header-nav .menu-item-has-children"
    );

    // Se clicou num sub-link (dentro de .sub-menu), deixa navegar normalmente
    if (clickedLink && clickedLink.closest(".sub-menu")) {
      return;
    }

    if (!parentItem) {
      return;
    }

    const link = parentItem.querySelector(":scope > a");
    if (!link) return;

    const submenu = parentItem.querySelector(":scope > .sub-menu");
    if (!submenu) return;

    const isActive = submenu.classList.contains("active");

    // Se já está aberto e o usuário clicou no link pai, deixa navegar
    if (isActive && clickedLink === link) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const scope = link.closest(".main-header-nav");
    resetAll(scope);

    if (!isActive) {
      link.classList.add("open");
      submenu.classList.add("active");
    }
  });
}

export { changePointerEventsHeaderMobile };
